<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Pago del Resumen">
          <b-table 
              small
              class="data-display"  
              responsive="sm"
              :busy="tableBusy" 
              :items="tarjetaResumenPagoDatos" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Efectivo" v-if="tarjetaResumenPagoDocumentos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="tarjetaResumenPagoDocumentos" 
              :fields="documentosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!-- <template v-slot:cell(documentoNumero)="data">
              {{ data.item.documentoNumero }}
            </template> -->
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Debitos" v-if="tarjetaResumenPagoDebitos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="tarjetaResumenPagoDebitos" 
              :fields="debitosFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'tarjetaResumenPago/getField',
  mutationType: 'tarjetaResumenPago/updateField',
});

export default {
  name: 'TarjetasResumenesPagosData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      documentosFields: [
        { 
          key: 'documentoTipo',
          label: 'Moneda'
        },
        // { 
        //   key: 'documentoNumero',
        //   label: 'Nro.Documento'
        // },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      debitosFields: [
        {
          key: 'fechaCreditoDebito',
          label: 'Fecha Debito'
        },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      tableBusy: false
    }
  },
  computed: {
    ...mapFields([
      'tarjetaResumenPagoDatos',
      'tarjetaResumenPagoDocumentos',
      'tarjetaResumenPagoDebitos'
    ]),
  },
  created() {
    let tarjetaResumenPagoId = this.$route.params.id;

    this.tableBusy = true;
    this.$store.dispatch('tarjetaResumenPago/getDatos', tarjetaResumenPagoId)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
